<template>
    <div :class="['form-input-radio-button', { 'active': isActive, 'form-input-radio-button--danger': danger, 'form-input-radio-button--with-input': textInput !== null }]" @click="onClick">
        <div class="form-input-radio-button-inner">
            <figure v-if="icon" class="form-input-radio-button-icon" v-html="icon"></figure>
            <span class="label-static" v-html="value"></span>
            <figure class="form-input-radio-button-selector">
                <template v-if="isActive">
                    <svg v-if="isSending" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>
                    <template v-else>
                        <span v-if="danger" class="material-symbols-rounded times">close</span>
                        <span class="material-symbols-rounded check">check</span>
                    </template>
                </template>
                <span v-else></span>
            </figure>
        </div>

        <div class="form-input-radio-button-form" v-if="isActive && textInput !== null">
            <form-input-type-text-area
                name="text"
                :label="textInput"
                :errors="errors"
                auto-grow
            ></form-input-type-text-area>

            <v-button label="Senden" type="submit" @onClick="onClick"></v-button>
        </div>  

        <p v-if="text">{{ text }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            errors: {
                type: Array,
                required: false,
                default: null
            },

            icon: {
                type: String,
                required: false,
                default: null
            },

            danger: {
                type: Boolean,
                required: false,
                default: false
            },

            value: {
                type: String,
                required: true
            },

            textInput: {
                type: String,
                required: false,
                default: null
            },

            isSending: {
                type: Boolean,
                required: false
            },

            text: {
                type: String,
                required: false
            },
        },

        data() {
            return {
                inputValue: this.value.replace(/(&shy;)/gi, ""),
                hasError: false,
                isActive: false
            }
        },

        watch: {
            inputValue(value) {
                if (value.length > 0) {
                    this.hasError = false
                }
            },

            errors: {
                immediate: true,
                handler(errors) {
                    if (errors === null || errors === undefined || errors.length === 0) {
                        this.hasError = false
                    } else {
                        this.hasError = true
                    } 
                }
            }
        },

        mounted() {
            Vuemit.listen('CardInput--activated', this.onActivated)
        },

        methods: {
            onClick() {
                Vuemit.fire('CardInput--activated', true) 
                this.isActive = true
                this.$emit('onClick')
            },
        
            onActivated() {
                this.isActive = false
            }
        }
    }
</script>
